const options = ['A','B','C','D']

export default (question, selectAnswer) => {
    if(!question || !selectAnswer) return ''
    const answer = String(selectAnswer || question.answer)
    return [3,4,7].indexOf(question.type)>-1?answer.split(',').sort().map(v=>['A','B','C','D'][v]+'. '+question[['A','B','C','D'][v]]).join('<br>'):answer
}